//copy from constants/permissions.js
//using commonjs so that it is copied from backend easily
//keep the module name as prefix then split from the permission part by '.' and use snake_case ('-' as separator) for the permission part.
const PERMISSIONS = {
  //dashboard
  DASHBOARD_BRANCH: 'dashboard:branch',
  DASHBOARD_OVERALL: 'dashboard:overall',
  DASHBOARD_POINT: 'dashboard:point',
  DASHBOARD_COUPON: 'dashboard:coupon',
  DASHBOARD_PACKAGE: 'dashboard:package',
  DASHBOARD_PROMOTION: 'dashboard:promotion',
  DASHBOARD_WALLET: 'dashboard:wallet',
  DASHBOARD_SALES: 'dashboard:sales',
  DASHBOARD_GROUP: 'dashboard:group',

  //branch
  BRANCH_VIEW: 'branch:view',
  BRANCH_EDIT: 'branch:edit',
  BRANCH_MANAGEMENT: 'branch:management',
  BRANCH_INVITE: 'branch:invite',

  //contact
  CONTACT_TEMPLATE_MANAGEMENT: 'contact:template-management',
  CONTACT_VIEW: 'contact:view',
  CONTACT_CAN_ASSIGN: 'contact:can-assign',
  CONTACT_CAN_EDIT_BOARD: 'contact:can-edit-board',

  //advertisement
  ADVERTISEMENT_VIEW_LIST: 'advertisement:view-list',
  ADVERTISEMENT_CREATE: 'advertisement:create',
  ADVERTISEMENT_EDIT: 'advertisement:edit',
  ADVERTISEMENT_DELETE: 'advertisement:delete',

  //broadcast
  BROADCAST_VIEW: 'broadcast:view',
  BROADCAST_VIEW_HISTORY: 'broadcast:view-history',
  BROADCAST_CREATE_WHATSAPP: 'broadcast:create-whatsapp',
  BROADCAST_CREATE_LINE: 'broadcast:create-line',
  BROADCAST_EDIT: 'broadcast:edit',
  BROADCAST_DELETE: 'broadcast:delete',
  BROADCAST_RECURRING_VIEW: 'broadcast:recurring-view',
  BROADCAST_RECURRING_CREATE: 'broadcast:recurring-create',
  BROADCAST_RECURRING_EDIT: 'broadcast:recurring-edit',
  BROADCAST_RECURRING_CHANGE_STATUS: 'broadcast:recurring-change-status',
  BROADCAST_RECURRING_VIEW_HISTORY: 'broadcast:recurring-view-history',

  //shop product
  SHOP_PRODUCT_VIEW_LIST: 'shop_product:view-list',
  SHOP_PRODUCT_CREATE: 'shop_product:create',
  SHOP_PRODUCT_EDIT: 'shop_product:edit',
  SHOP_PRODUCT_VIEW_CATEGORY: 'shop_product:view-category',
  SHOP_PRODUCT_CREATE_CATEGORY: 'shop_product:create-category',
  SHOP_PRODUCT_EDIT_CATEGORY: 'shop_product:edit-category',
  SHOP_PRODUCT_DELETE_CATEGORY: 'shop_product:delete-category',
  SHOP_PRODUCT_CHANGE_STATUS: 'shop_product:change-status',
  SHOP_PRODUCT_VIEW_STOCK: 'shop_product:view-stock',
  SHOP_PRODUCT_VIEW_STOCK_HISTORY: 'shop_product:view-stock-history',
  SHOP_PRODUCT_EDIT_STOCK: 'shop_product:edit-stock',
  SHOP_PRODUCT_ADD_ON_VIEW: 'shop_product:add-on-view',
  SHOP_PRODUCT_ADD_ON_CREATE: 'shop_product:add-on-create',
  SHOP_PRODUCT_ADD_ON_EDIT: 'shop_product:add-on-edit',
  SHOP_PRODUCT_ADD_ON_GROUP_VIEW: 'shop_product:add-on-group-view',
  SHOP_PRODUCT_ADD_ON_GROUP_CREATE: 'shop_product:add-on-group-create',
  SHOP_PRODUCT_ADD_ON_GROUP_EDIT: 'shop_product:add-on-group-edit',
  SHOP_PRODUCT_ADD_ON_GROUP_DELETE: 'shop_product:add-on-group-delete',

  //shopping cart
  SHOPPING_PAYMENT_SETTING_VIEW: 'shopping:payment-setting-view',
  SHOPPING_PAYMENT_SETTING_EDIT: 'shopping:payment-setting-edit',
  SHOPPING_SHIPPING_MANAGEMENT_VIEW: 'shopping:shipping-management-view',
  SHOPPING_SHIPPING_MANAGEMENT_CREATE: 'shopping:shipping-management-create',
  SHOPPING_SHIPPING_MANAGEMENT_EDIT: 'shopping:shipping-management-edit',
  SHOPPING_SHIPPING_MANAGEMENT_DELETE: 'shopping:shipping-management-delete',
  SHOPPING_CART_SETTING_VIEW: 'shopping:shopping-cart-setting-view',
  SHOPPING_CART_SETTING_EDIT: 'shopping:shopping-cart-setting-edit',
  SHOPPING_ORDER_MANAGEMENT: 'shopping:order-management',
  SHOPPING_ORDER_VIEW: 'shopping:order-view',
  SHOPPING_ORDER_CREATE: 'shopping:order-create',

  //booking
  BOOKING_VIEW_LIST: 'booking:view-list',
  BOOKING_MANAGEMENT: 'booking:management',
  BOOKING_SETTING: 'booking:setting',
  BOOKING_INVITE: 'booking:invite',

  //booking2
  BOOKING2_VIEW_LIST: 'booking2:view-list',
  BOOKING2_MANAGEMENT: 'booking2:management',
  BOOKING2_SETTING: 'booking2:setting',
  BOOKING2_INVITE: 'booking2:invite',
  BOOKING2_CREATE: 'booking2:create',

  //package
  PACKAGE_VIEW: 'package:view',
  PACKAGE_CREATE: 'package:create',
  PACKAGE_EDIT: 'package:edit',
  PACKAGE_CHANGE_STATUS: 'package:change-status',
  PACKAGE_REDEEM: 'package:redeem',
  PACKAGE_VIEW_CUSTOMER_ITEMS: 'package:view-customer-items',
  PACKAGE_CREATE_CUSTOMER_ITEMS: 'package:create-customer-items',
  PACKAGE_EDIT_CUSTOMER_ITEMS: 'package:edit-customer-items',
  PACKAGE_DELETE_CUSTOMER_ITEMS: 'package:delete-customer-items',
  PACKAGE_VIEW_CUSTOMER_HISTORY: 'package:view-customer-history',

  //promotion
  PROMOTION_VIEW: 'promotion:view',
  PROMOTION_CREATE: 'promotion:create',
  PROMOTION_EDIT: 'promotion:edit',
  PROMOTION_CHANGE_STATUS: 'promotion:change-status',
  PROMOTION_VIEW_CUSTOMERS: 'promotion:view-customers',
  PROMOTION_REDEEM_FOR_CUSTOMER: 'promotion:redeem-for-customer',

  //coupon
  COUPON_VIEW: 'coupon:view',
  COUPON_CREATE: 'coupon:create',
  COUPON_EDIT: 'coupon:edit',
  COUPON_CHANGE_STATUS: 'coupon:change-status',
  COUPON_VIEW_HISTORY: 'coupon:view-history',
  COUPON_VIEW_CUSTOMER_HISTORY: 'coupon:view-customer-history',
  COUPON_USE_FOR_CUSTOMERS: 'coupon:use-for-customers',

  //recommender qr
  RECOMMENDER_QR_VIEW: 'recommender-qr:view',
  RECOMMENDER_QR_CREATE: 'recommender-qr:create',
  RECOMMENDER_QR_EDIT: 'recommender-qr:edit',
  RECOMMENDER_QR_DELETE: 'recommender-qr:delete',

  //member
  MEMBER_VIEW: 'member:view',
  MEMBER_INVITE: 'member:invite',
  MEMBER_VIEW_GROUPS: 'member:view-groups',
  MEMBER_CREATE_GROUPS: 'member:create-groups',
  MEMBER_EDIT_GROUPS: 'member:edit-groups',
  MEMBER_EDIT_CUSTOMER_GROUPS: 'member:edit-customer-groups',
  MEMBER_DELETE_GROUPS: 'member:delete-groups',
  MEMBER_CONFIG_TIERS: 'member:config-tiers',
  MEMBER_TOGGLE_GROUP_HOME_DISPLAY: 'member:toggle-group-home-display',
  MEMBER_INVITE_TO_GROUP: 'member:invite-to-group',
  MEMBER_MANAGE_ADMIN: 'member:admin-management',
  MEMBER_EDIT_PROFILE: 'member:edit-profile',
  MEMBER_CREATE: 'member:create',
  MEMBER_VIEW_GROUP_HISTORY: 'member:view-group-history',

  //deposit
  DEPOSIT_VIEW: 'deposit:view',
  DEPOSIT_CREATE: 'deposit:create',
  DEPOSIT_EDIT: 'deposit:edit',
  DEPOSIT_DELETE: 'deposit:delete',

  //MGM
  MGM_MANAGEMENT: 'mgm:management',
  MGM_VIEW_HISTORY: 'mgm:view-history',
  MGM_VIEW_REPORT: 'mgm:report',
  MGM_VIEW_CUSTOMER_HISTORY: 'mgm:view-customer-history',

  //funsharing
  FUNSHARING_VIEW_LIST: 'funsharing:view-list',
  FUNSHARING_CREATE: 'funsharing:create',
  FUNSHARING_EDIT: 'funsharing:edit',
  FUNSHARING_VIEW_HISTORY: 'funsharing:view-history',
  FUNSHARING_VIEW_REPORT: 'funsharing:view-report',
  FUNSHARING_VIEW_CUSTOMER_HISTORY: 'funsharing:view-customer-history',

  //point
  POINT_HISTORY: 'point:history',
  POINT_ADD_BY_CUSTOMER: 'point:add-by-customer',
  POINT_ADD_BY_PHONE: 'point:add-by-phone',
  POINT_ADD_BY_QR: 'point:add-by-qr',
  POINT_ADD_BY_PERMANENT_QR: 'point:add-by-permanent-qr',
  POINT_ADD_BY_PERMANENT_QR_DELETE: 'point:add-by-permanent-qr-delete',
  POINT_ADD_BY_PERMANENT_QR_CREATE: 'point:add-by-permanent-qr-create',
  POINT_VIEW_CUSTOMER_HISTORY: 'point:view-customer-history',
  POINT_EXPIRABLE_VIEW_CUSTOMER_HISTORY: 'point:expirable-view-customer-history',
  POINT_CLEAR_ALL: 'point:clear-all',
  POINT_CLEAR_ACCUMULATED: 'point:clear-accumulated',

  //sales
  SALES_CLEAR_ALL: 'point:sales-clear-all',

  //wallet
  WALLET_HISTORY: 'wallet:history',
  WALLET_ADD_BY_CUSTOMER: 'wallet:add-by-customer',
  WALLET_ADD_BY_PHONE: 'wallet:add-by-phone',
  WALLET_ADD_BY_QR: 'wallet:add-by-qr',
  WALLET_VIEW_CUSTOMER_HISTORY: 'wallet:view-customer-history',
  WALLET_EXPIRABLE_VIEW_CUSTOMER_HISTORY: 'wallet:expirable-view-customer-history',

  //setting
  SETTING_SHOP_VIEW: 'setting:shop-view',
  SETTING_SHOP_EDIT: 'setting:shop-edit',
  SETTING_NEW_USER_VIEW: 'setting:new-user-view',
  SETTING_NEW_USER_EDIT: 'setting:new-user-edit',
  SETTING_CONVERSION_RATE_VIEW: 'setting:conversion-rate-view',
  SETTING_CONVERSION_RATE_EDIT: 'setting:conversion-rate-edit',
  SETTING_THEME_VIEW: 'setting:theme-view',
  SETTING_THEME_EDIT: 'setting:theme-edit',
  SETTING_SHORTCUT_VIEW: 'setting:shortcut-view',
  SETTING_SHORTCUT_EDIT: 'setting:shortcut-edit',
  SETTING_LINE_VIEW: 'setting:line-view',
  SETTING_LINE_EDIT: 'setting:line-edit',
  SETTING_CONTACT_VIEW: 'setting:contact-view',
  SETTING_CONTACT_EDIT: 'setting:contact-edit',
  SETTING_NOTIFICATION_VIEW: 'setting:notification-view',
  SETTING_NOTIFICATION_EDIT: 'setting:notification-edit',
  SETTING_CONDITION_VIEW: 'setting:condition-view',
  SETTING_CONDITION_EDIT: 'setting:condition-edit',

  //notification
  NOTIFICATION_VIEW: 'notification:view',

  //report
  REPORT_ACCESS: 'report:access',
  REPORT_CUSTOMER_DETAIL: 'report:customer-detail',
  REPORT_ACTIVITY: 'report:activity',
  REPORT_POINT_HISTORY: 'report:point-history',
  REPORT_WALLET_HISTORY: 'report:wallet-history',
  REPORT_SALES_HISTORY: 'report:sales-history',
  REPORT_REDEEM: 'report:redeem',
  REPORT_COUPON_SHOP: 'report:coupon-shop',
  REPORT_COUPON_USAGE: 'report:coupon-usage',
  REPORT_PACKAGE_SHOP: 'report:package-shop',
  REPORT_PACKAGE_CUSTOMER: 'report:package-customer',
  REPORT_PACKAGE_USAGE_HISTORY: 'report:package-usage-history',
  REPORT_DEPOSIT_HISTORY: 'report:deposit-history',
  REPORT_BOOKING_HISTORY: 'report:booking-history',
  REPORT_BOOKING2_HISTORY: 'report:booking-history2',
  REPORT_ORDER_DETAIL: 'report:order-detail',
  REPORT_ORDER_ITEMS: 'report:order-items',
  REPORT_ORDER_SUMMARY: 'report:order-summary',
  REPORT_STOCK_INVENTORY: 'report:stock-inventory',
  REPORT_STOCK_TRANSACTION: 'report:stock-transaction',
  REPORT_COMMISSION_ENTRIES: 'report:commission-entries',
  REPORT_COMMISSION_SUMMARY: 'report:commission-summary',
  REPORT_GROUP_MEMBERSHIP: 'report:group-membership',

  //ai
  AI_MANAGEMENT: 'ai:management',

  //Smart POS API
  SMART_POS_FULL_ACCESS: 'smart-pos:full-access',

  //MINIPOS
  MINIPOS_ACCESS: 'minipos:access',

  //upload
  UPLOAD_ACCESS: 'upload:access',
  UPLOAD_ADD_MEMBER: 'upload:add-member',
  UPLOAD_ADD_POINT: 'upload:add-point',
  UPLOAD_ADD_GROUP: 'upload:add-group',
  UPLOAD_ADD_SHOP_PRODUCT: 'upload:add-shop-product',
  UPLOAD_ADD_SHOP_PRODUCT_STOCK: 'upload:add-shop-product-stock',
  UPLOAD_ADD_SHOP_PRODUCT_CATEGORY: 'upload:add-shop-product-category',
  UPLOAD_ADD_PACKAGE: 'upload:add-package',
  UPLOAD_ADD_PROMOTION: 'upload:add-promotion',
  UPLOAD_ADD_COUPON: 'upload:add-coupon',
  UPLOAD_ADD_DEPOSIT: 'upload:add-deposit',
  UPLOAD_UPDATE_DEPOSIT: 'upload:update-deposit',

  //auto promotions
  AUTO_PROMOTION_VIEW: 'auto-promotion:view',
  AUTO_PROMOTION_CREATE: 'auto-promotion:create',
  AUTO_PROMOTION_EDIT: 'auto-promotion:edit',
  AUTO_PROMOTION_CHANGE_STATUS: 'auto-promotion:change-status'
};

//check permission convention
Object.values(PERMISSIONS).forEach(permission => {
  if (permission.split(':').length !== 2) {
    throw new Error(`Permission "${permission}" does not follow the convention of "module:action"`);
  }
});

Object.freeze(PERMISSIONS);
exports.PERMISSIONS = PERMISSIONS;

// Permissions excluded when switching role type between HQ and branch
const HQ_BRANCH_SWITCH_EXCLUDED_PERMISSIONS = [
  PERMISSIONS.SHOP_PRODUCT_CREATE,
  PERMISSIONS.SHOP_PRODUCT_EDIT,
  PERMISSIONS.SHOP_PRODUCT_CREATE_CATEGORY,
  PERMISSIONS.SHOP_PRODUCT_EDIT_CATEGORY,
  PERMISSIONS.SHOP_PRODUCT_DELETE_CATEGORY,
  PERMISSIONS.SHOP_PRODUCT_CHANGE_STATUS,
  PERMISSIONS.SHOPPING_SHIPPING_MANAGEMENT_CREATE,
  PERMISSIONS.SHOPPING_SHIPPING_MANAGEMENT_EDIT,
  PERMISSIONS.SHOPPING_SHIPPING_MANAGEMENT_DELETE,
  PERMISSIONS.SHOPPING_CART_SETTING_EDIT,
  PERMISSIONS.PACKAGE_CREATE,
  PERMISSIONS.PACKAGE_EDIT,
  PERMISSIONS.PACKAGE_CHANGE_STATUS,
  PERMISSIONS.PROMOTION_CREATE,
  PERMISSIONS.PROMOTION_EDIT,
  PERMISSIONS.PROMOTION_CHANGE_STATUS,
  PERMISSIONS.COUPON_CREATE,
  PERMISSIONS.COUPON_EDIT,
  PERMISSIONS.COUPON_CHANGE_STATUS,
  PERMISSIONS.RECOMMENDER_QR_CREATE,
  PERMISSIONS.RECOMMENDER_QR_EDIT,
  PERMISSIONS.RECOMMENDER_QR_DELETE,
  PERMISSIONS.MEMBER_MANAGE_ADMIN,
  PERMISSIONS.MEMBER_CREATE_GROUPS,
  PERMISSIONS.MEMBER_EDIT_GROUPS,
  PERMISSIONS.MEMBER_DELETE_GROUPS,
  PERMISSIONS.MEMBER_CONFIG_TIERS,
  PERMISSIONS.MEMBER_TOGGLE_GROUP_HOME_DISPLAY,
  PERMISSIONS.BRANCH_EDIT,
  PERMISSIONS.SETTING_SHOP_EDIT,
  PERMISSIONS.SETTING_NEW_USER_EDIT,
  PERMISSIONS.SETTING_THEME_EDIT,
  PERMISSIONS.SETTING_SHORTCUT_EDIT,
  PERMISSIONS.SETTING_LINE_EDIT,
  PERMISSIONS.SETTING_CONTACT_EDIT,
  PERMISSIONS.SETTING_NOTIFICATION_EDIT,
  PERMISSIONS.SETTING_CONDITION_EDIT,
  PERMISSIONS.SETTING_CONDITION_EDIT,
  PERMISSIONS.ADVERTISEMENT_CREATE,
  PERMISSIONS.ADVERTISEMENT_EDIT,
  PERMISSIONS.ADVERTISEMENT_DELETE,
  PERMISSIONS.AUTO_PROMOTION_CREATE,
  PERMISSIONS.AUTO_PROMOTION_EDIT,
  PERMISSIONS.AUTO_PROMOTION_CHANGE_STATUS,
  PERMISSIONS.POINT_CLEAR_ALL,
  PERMISSIONS.POINT_CLEAR_ACCUMULATED,
  PERMISSIONS.SALES_CLEAR_ALL
];

Object.freeze(HQ_BRANCH_SWITCH_EXCLUDED_PERMISSIONS);
exports.HQ_BRANCH_SWITCH_EXCLUDED_PERMISSIONS = HQ_BRANCH_SWITCH_EXCLUDED_PERMISSIONS;
